import React from "react";
import Button from "../buttons";
import { Modal } from "react-bootstrap";
import { ModalConfirmation } from "../../types/DefModalOptions";
import { confirmable, createConfirmation } from "../../hooks/DialogMountPoint";
import ThemedModal from "../utilities/ThemedModal";

export type ButtonVariants = 'primary' | 'success' | 'danger' | 'warning' | 'light';
export type ConfirmModalOptions = {
    allowConfirmButton?: boolean,
    cancelButtonText?: string,
    cancelButtonVariant?: ButtonVariants,
    confirmButtonText?: string,
    confirmButtonVariant?: ButtonVariants,
    dialogTitle?: string | null | undefined,
    message: JSX.Element | string
};

export type ConfirmModalProps = ModalConfirmation<any> & ConfirmModalOptions;

export const ConfirmModalMessageText = ({ children } : Readonly<{ children: JSX.Element | string }>) => <p className="m-0">{children}</p>
export const ConfirmModal = ({ 
    allowConfirmButton = true,
    backdrop = 'static',
    cancel,
    cancelButtonText = 'Close',
    cancelButtonVariant = 'light',
    centered = true,
    confirmButtonText = 'Confirm',
    confirmButtonVariant = 'success',
    defaultValues,
    dialogId,
    dialogTitle,
    dismiss,
    message,
    proceed,
    show,
    size = "lg",
    ...rest
} : Readonly<ConfirmModalProps>) => {

    const onClose = () : void => proceed!(false);

    const onProceed = () : void => proceed!(true);

    return (
        <Modal backdrop={backdrop} centered={centered} size={size} show={show} onHide={onClose} {...rest}>
            <ThemedModal.Header>
                <Modal.Title>{dialogTitle ?? 'Are you sure?'}</Modal.Title>
            </ThemedModal.Header>
            <Modal.Body>
                {message}
            </Modal.Body>
            <Modal.Footer>
                {allowConfirmButton && (<Button variant={confirmButtonVariant} onClick={onProceed}>{confirmButtonText}</Button>)}
                <Button variant={cancelButtonVariant} onClick={onClose}>{cancelButtonText}</Button>
            </Modal.Footer>
        </Modal>
    );
};

export function openConfirmModal(opts: ConfirmModalOptions) {
    return createConfirmation<ConfirmModalProps, any>(confirmable(ConfirmModal))({
        ...opts,
        dialogId: 'confirm_action_modal'
    });
}

export default ConfirmModal;